import React from 'react'

function PatientDiagnosis() {
  return (
    <>
     test
    </>
  )
}

export default PatientDiagnosis
